var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2308 24.875H21L36 11.375V11.7607V24.1036C36 24.7207 35.4872 24.875 35.2308 24.875Z",
    fill: "#C6DAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.768 12.65C34.9235 12.5115 35.0893 12.3837 35.2637 12.2672V24.3359C35.2625 24.3372 35.2613 24.338 35.2606 24.3385H35.2604H21.7758C21.9502 24.1024 22.152 23.8811 22.3796 23.6786L34.768 12.65ZM21 84.6285V28.3385H35.2604C37.4512 28.3385 39.2637 26.5638 39.2637 24.3379V11.4219H94.2681C96.8755 11.4219 99 13.3132 99 15.6343V80.8785L97.5 79.3785L90.375 86.5035L83.25 79.3785L76.125 86.5035L69 79.3785L61.875 86.5035L54.75 79.3785L47.625 86.5035L40.5 79.3785L33.375 86.5035L26.25 79.3785L21 84.6285ZM21 88.8712V105.459C21 107.781 23.1245 109.672 25.7319 109.672H94.2681C96.8755 109.672 99 107.781 99 105.459V85.1212L97.5 83.6212L90.375 90.7462L83.25 83.6212L76.125 90.7462L69 83.6212L61.875 90.7462L54.75 83.6212L47.625 90.7462L40.5 83.6212L33.375 90.7462L26.25 83.6212L21 88.8712Z",
    fill: "#E4EEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2308 24.875H21L36 11.375V11.7607V24.1036C36 24.7207 35.4872 24.875 35.2308 24.875Z",
    fill: "#C6DAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69.875L60 29.375L84 69.875H36ZM60 63.4803C60.6182 63.4803 61.1364 63.276 61.5545 62.8674C61.9727 62.4589 62.1818 61.9526 62.1818 61.3487C62.1818 60.7447 61.9727 60.2385 61.5545 59.8299C61.1364 59.4214 60.6182 59.2171 60 59.2171C59.3818 59.2171 58.8636 59.4214 58.4455 59.8299C58.0273 60.2385 57.8182 60.7447 57.8182 61.3487C57.8182 61.9526 58.0273 62.4589 58.4455 62.8674C58.8636 63.276 59.3818 63.4803 60 63.4803ZM57.8182 57.0855H62.1818V46.4276H57.8182V57.0855Z",
    fill: "#C6DAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmpty);
export default __webpack_public_path__ + "static/media/img_empty.763f8af6dcac52e5369a62ffde1127f0.svg";
export { ForwardRef as ReactComponent };